import { render, staticRenderFns } from "./addMall.vue?vue&type=template&id=9cebedcc&scoped=true&"
import script from "./addMall.vue?vue&type=script&lang=js&"
export * from "./addMall.vue?vue&type=script&lang=js&"
import style0 from "./addMall.vue?vue&type=style&index=0&id=9cebedcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cebedcc",
  null
  
)

export default component.exports